import { mdiLayers, mdiMagnify, mdiShareVariant, mdiWrench } from '@mdi/js';
import { Component, Vue } from 'vue-property-decorator';

import NestedDrawer from '../ui/NestedDrawer/NestedDrawer.vue';

import type { DrawerItem } from '../ui/NestedDrawer/NestedDrawer';

@Component({
  components: {
    NestedDrawer,
  },
})
export default class MapSidebar extends Vue {
  activePanel = 0;
  get sidebarPanels(): DrawerItem[] {
    const items: DrawerItem[] = [
      {
        title: this.$t('Layers'),
        icon: mdiLayers,
        component: (): any => import('../LayersTab/LayersTab.vue'),
      },
      {
        title: this.$t('Search'),
        icon: mdiMagnify,
        component: (): any => import('../SearchTab/SearchTab.vue'),
      },
      // {
      //   title: 'Tree',
      //   icon: 'playlist_add',
      //   component: (): any => import('../ResourceTreeTab/ResourceTreeTab.vue'),
      // },
    ];

    items.push({
      title: this.$t('Share'),
      icon: mdiShareVariant,
      component: (): any => import('../ShareTab/ShareTab.vue'),
    });

    items.push({
      title: this.$t('Settings'),
      icon: mdiWrench,
      component: (): any => import('../SettingsTab/SettingsTab.vue'),
    });

    return items;
  }
}
